import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable, ErrorHandler } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ToastController, Toast, App } from "ionic-angular";
import { Network } from "@ionic-native/network";
import { DemoProvider } from "../demo/demo";
import { ResetnavProvider } from "../resetnav/resetnav";
import "rxjs/add/operator/do";

@Injectable()
export class InterceptorProvider implements HttpInterceptor, ErrorHandler {
  toastObject: Toast;
  toastError: Toast;

  constructor(
    private toast: ToastController,
    private network: Network,
    private demo: DemoProvider,
    private resetNav: ResetnavProvider
  ) {
    this.network.onConnect().subscribe(() => {
      if (this.toastObject) {
        this.toastObject.dismiss();
      }
    });
    this.network.onDisconnect().subscribe(() => {
      this.toastObject = this.toast.create({
        message: "There is no internet connection",
        duration: 3000,
      });
      this.toastObject.present();
    });
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let req = request;
    if (this.demo.demoMode) {
      const httpRequest = new HttpRequest(
        <any>req.method,
        this.mapUrlToDemoStorage(request.url),
        {},
        { headers: request.headers }
      );
      req = Object.assign(req, httpRequest);
    }
    return next.handle(req).do(
      () => {},
      (error: HttpErrorResponse) => {
        this.handleError(error);
      }
    );
  }

  handleError(error: Error | HttpErrorResponse): void {
    if (error instanceof HttpErrorResponse) {
      if (error.ok === false) {
        if (error.status === 401) {
          const currentEvent = this.resetNav.event.getValue();
          this.resetNav.event.next(currentEvent + 1);
        }
      }
    }
  }

  mapUrlToDemoStorage(url: string): string {
    let urlSplit = url.split("?");
    if (url.includes("period") || url.includes("events/trains")) {
      return urlSplit[0] + "/" + urlSplit[1] + "/index.json";
    } else if (url.includes("signals/tags") || url.includes("daily")) {
      return urlSplit[0] + "/" + urlSplit[1] + "/index.json";
    } else {
      return urlSplit[0] + "/index.json";
    }
    // return url + "/index.json";
  }

  isNative() {
    if (!document.URL.startsWith("http")) {
      return "/";
    } else {
      return "/";
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/interceptor/interceptor.ts